import React, {} from 'react';
import { Link } from 'react-router-dom';
import styles from "../../Table/ReactTableBase.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faExternalLink, faXmark} from "@fortawesome/free-solid-svg-icons";
import AxiosConfig from "../../../services/AxiosConfig";
import ReactTableBase from "../../Table/ReactTableBase";
import RenderCellActif from "../../Table/RenderCellActif";
import RenderCellSplit from "../../Table/RenderCellSplit";
import {useModal} from "../../../contexts/ModalContext";
import RenderCellLogo from "../../Table/RenderCellLogo";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";

const EntreprisesTable = ({ entreprises, putActifOpenModal = null, setImage = null }) => {
    const data = React.useMemo(() => entreprises, [entreprises]);
    const {showModal, hideModal} = useModal();

    const handleSuccess = (children = "Enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    const renderCellName = ({ row }) => {
        return  <Link to={Routing.generate({
            route: Routing.routes.adminEntreprise,
            params: {entrepriseId: row.original.id},
        })}>{RenderCellSplit({ value: row.original.nom })}</Link>;
    }

    const renderCellCreated = ({ value }) => {
        return DateService.formatDate(value);
    }

    const renderCellActions = ({ row }) => {
        return (
            <div className={styles.actions}>
                <Link to={Routing.generate({
                    route: Routing.routes.adminEntreprise,
                    params: {entrepriseId: row.original.id},
                })} title={"Détail"} >
                    <FontAwesomeIcon icon={faExternalLink}/>Détail
                </Link>
                <Link to={Routing.generate({
                    route: Routing.routes.adminEntreprise,
                    params: {entrepriseId: row.original.id},
                    queryParams: {mode: 'creation'},
                })} title={"Modifier"} >
                    <FontAwesomeIcon icon={faEdit}/>Modifier
                </Link>
                <Link to={Routing.generate({
                    route: Routing.routes.adminContrats,
                    params: {entrepriseId: row.original.id},
                })} title={"Contrats"} >
                    <FontAwesomeIcon icon={faExternalLink} />Contrats
                </Link>
                <Link to={Routing.generate({
                    route: Routing.routes.adminEntrepriseSalaries,
                    params: {entrepriseId: row.original.id},
                })} title={"Salariés"} >
                    <FontAwesomeIcon icon={faExternalLink} />Salariés
                </Link>
            </div>
        );
    }

    const handleSubmitLogo = async (values, {setSubmitting, resetForm, setErrors, row}) => {
        if (values.file) {
            const formData = new FormData();
            formData.append("file", values.file);

            try {
                const response = await AxiosConfig.post(`/admin/entreprises/${row.original.id}/logo`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.data.success) {
                    handleSuccess("Logo enregistré avec succès");
                    setImage(row.original.id, response.data.entreprise);
                } else {
                    handleError("Logo non enregistré suite à une erreur.");
                }
                resetForm();
            } catch (error) {
                console.error("Erreur lors de l'upload du fichier", error);
            }
        } else {
            setErrors({file: "Un fichier est requis"});
        }

        setSubmitting(false);
    };

    const columns = [
            /*{
                Header: 'Id',
                accessor: 'id',
                Cell: renderCellId,
            },*/
        {
            Header: 'Nom',
            accessor: 'nom',
            Cell: renderCellName,
        },
            {
                Header: 'Logo',
                accessor: 'logo',
                Cell: (props) => <RenderCellLogo {...props} handleSubmitLogo={handleSubmitLogo} />,
            },
            {
                Header: 'Ville',
                accessor: 'ville',
                Cell: RenderCellSplit,
            },
            {
                Header: 'Crée le',
                accessor: 'created',
                Cell: renderCellCreated,
            },
            {
                Header: 'État',
                accessor: 'actif',
                isBoolean: true,
                Cell: (props) => <RenderCellActif {...props} putActifOpenModal={putActifOpenModal} />,
            },
            {
                Header: 'Actions',
                id: 'actions',
                Cell: renderCellActions,
            },
        ];

    return (
        <ReactTableBase dataSource={entreprises} columnsData={columns} />
    );
};

export default EntreprisesTable;
